module.exports = "/_next/static/images/balance-dashboard-d5227751db336e8090e11c969c12dc54.svg";